module.exports = __webpack_public_path__ + "static/media/icon-facebook.c3fb3cd9.svg";